import { render, staticRenderFns } from "./PrescriptionSummary.vue?vue&type=template&id=44eac22d&scoped=true"
import script from "./PrescriptionSummary.vue?vue&type=script&lang=ts"
export * from "./PrescriptionSummary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44eac22d",
  null
  
)

export default component.exports